import React, { createContext, useCallback, useState, useContext } from 'react';

import api from '../services/api';
import { apolloClient } from '../services/apollo';
import { gql } from '@apollo/client';
// import socket from '../services/socket';

const LOGOUT_MUTATION = gql`
  mutation Logout {
    logout
  }
`;

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    const refreshToken = localStorage.getItem('@AcordeOn:refreshToken');
    const token = localStorage.getItem('@AcordeOn:token');
    const user = localStorage.getItem('@AcordeOn:user');

    if (token && user && refreshToken) {
      // api.defaults.headers.authorization = `Bearer ${token}`;
      return {
        user: JSON.parse(user),
      };
    }

    return {};
  });

  const signIn = useCallback(async ({ email, password }) => {
    const response = await api.post('auth/signin', {
      email,
      password,
    });

    const { token, refreshToken, user } = response.data;

    localStorage.setItem('@AcordeOn:token', token);
    localStorage.setItem('@AcordeOn:refreshToken', refreshToken);
    localStorage.setItem('@AcordeOn:user', JSON.stringify(user));

    // api.defaults.headers.authorization = `Bearer ${token}`;

    setData({ token, refreshToken, user });
  }, []);

  // Função para atualizar o estado após login via GraphQL
  const setAuthFromGraphQL = useCallback(({ accessToken, refreshToken, user }) => {
    localStorage.setItem('@AcordeOn:token', accessToken);
    localStorage.setItem('@AcordeOn:refreshToken', refreshToken);
    localStorage.setItem('@AcordeOn:user', JSON.stringify(user));

    setData({ token: accessToken, refreshToken, user });
  }, []);

  const signOut = useCallback(() => {
    // Chama a mutation Logout da nova API GraphQL para invalidar tokens no servidor
    apolloClient.mutate({
      mutation: LOGOUT_MUTATION,
    }).catch(() => {
      // Ignora erros de logout - o importante é limpar o localStorage
    });

    localStorage.removeItem('@AcordeOn:token');
    localStorage.removeItem('@AcordeOn:refreshToken');
    localStorage.removeItem('@AcordeOn:user');

    // Limpa o cache do Apollo para evitar dados do usuário anterior
    apolloClient.clearStore();

    setData({});
  }, []);

  const updateUser = useCallback(
    user => {
      localStorage.setItem('@AcordeOn:user', JSON.stringify(user));

      setData({
        token: data.token,
        user,
      });
    },
    [setData, data.token]
  );

  return (
    <AuthContext.Provider
      value={{
        token: data.token,
        user: data.user,
        signIn,
        signOut,
        updateUser,
        setAuthFromGraphQL,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}

export { AuthProvider, useAuth };
